import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Button } from '../ui/Button';
export function ProblemSection() {
  const painPoints = [{
    text: 'Puede que estés alimentando a tu mascota con ingredientes que le hacen daño',
    bold: 'ingredientes que le hacen daño'
  }, {
    text: 'Muchos alimentos comerciales contienen conservantes, colorantes y subproductos que no elegirías para vos',
    bold: 'conservantes, colorantes y subproductos'
  }, {
    text: 'Problemas digestivos, alergias y falta de energía son más comunes de lo que creés — y la comida suele ser la causa',
    bold: 'Problemas digestivos, alergias y falta de energía'
  }, {
    text: 'No sabés con certeza qué alimentos son seguros y cuáles pueden ser tóxicos para tu perro o gato',
    bold: 'qué alimentos son seguros y cuáles pueden ser tóxicos'
  }, {
    text: 'Sentís culpa porque querés darle lo mejor, pero no sabés por dónde empezar',
    bold: 'Sentís culpa'
  }, {
    text: 'La desinformación en internet te confunde más de lo que te ayuda',
    bold: 'La desinformación'
  }];
  return <section className="py-10 md:py-12 px-4 bg-white relative overflow-hidden" data-id="element-205">
      {/* Subtle top accent line */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-danger/40 to-transparent" data-id="element-206"></div>

      <div className="max-w-3xl mx-auto" data-id="element-207">
        <div className="text-center mb-10" data-id="element-208">
          <p className="text-danger font-black uppercase tracking-widest text-sm mb-4" data-id="element-209">
            La realidad que nadie te cuenta
          </p>
          <h2 className="text-4xl md:text-5xl font-black text-forest-green leading-tight text-balance font-serif" data-id="element-210">
            ¿Estás seguro de que tu mascota está comiendo bien?
          </h2>
        </div>

        <div className="space-y-4" data-id="element-211">
          {painPoints.map((point, idx) => {
          const parts = point.text.split(point.bold);
          return <div key={idx} className="flex items-start gap-4 bg-cream/80 border border-gray-100 border-l-4 border-l-danger rounded-r-2xl rounded-l-sm p-5 md:p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-212">
                <AlertCircle className="w-6 h-6 text-danger flex-shrink-0 mt-1" data-id="element-213" />
                <p className="text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-214">
                  {parts[0]}
                  <strong className="text-danger font-black bg-danger/5 px-1 rounded" data-id="element-215">
                    {point.bold}
                  </strong>
                  {parts[1]}
                </p>
              </div>;
        })}
        </div>

        <div className="mt-12 text-center bg-cream/50 p-8 rounded-2xl border border-gold/20" data-id="element-216">
          <div className="w-20 h-1.5 bg-gold mx-auto rounded-full mb-6" data-id="element-217"></div>
          <p className="text-2xl md:text-3xl text-gray-800 font-medium italic leading-relaxed max-w-2xl mx-auto font-serif" data-id="element-218">
            La buena noticia es que no necesitás ser veterinario ni
            nutricionista para cambiar esto.
            <br data-id="element-219" />
            <span className="text-forest-green font-black not-italic block mt-4 text-3xl md:text-4xl" data-id="element-220">
              Solo necesitás el sistema correcto.
            </span>
          </p>
          <div className="mt-8" data-id="element-221">
            <Button fullWidth className="md:w-auto shadow-glow" data-id="element-222">
              QUIERO EL MEGA PACK DE ALIMENTOS
            </Button>
          </div>
        </div>
      </div>
    </section>;
}